<script lang="ts">
    import { getJetPerform } from '~/jet';
    import { getPlayback } from '~/utils/playback';
    import type { MediaItem } from '~/utils/playback/queue';
    import { getI18n } from '~/stores/i18n';

    import InteractivePlayButton from '@amp/web-app-components/src/components/buttons/InteractivePlayButton.svelte';

    const i18n = getI18n();
    const perform = getJetPerform();
    const playbackInstance = getPlayback();
    const { queue } = playbackInstance;

    export let item: MediaItem;
    export let ariaLabel: string = '';
    export let isExplicit: boolean = false;

    $: itemId = item.id;
    $: isNowPlayingItem = itemId && itemId.includes($queue.nowPlayingItemId);
    $: isLoading = isNowPlayingItem && $queue.derivedStates.isLoading;
    $: isPaused = isNowPlayingItem && $queue.derivedStates.isPaused;
    $: isPlaying = isNowPlayingItem && $queue.derivedStates.isPlaying;
</script>

<InteractivePlayButton
    {ariaLabel}
    {item}
    {isExplicit}
    {isLoading}
    {isPaused}
    {isPlaying}
    translateFn={$i18n.t}
    usePlayingBarsHover={true}
    on:pause={() => perform(item.pauseAction)}
    on:play={() => perform(item.playAction)}
    on:resume={() => perform(item.resumeAction)}
/>
